import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { microfrontendConfig } from '@/infrastructure/config/microfrontend.config';
import StudyPlan from '@/presentation/screens/study-plan';

import { ApplicationLayout } from '../layouts/application/application.layout';
import CertificatePublic from '../screens/certificate/public/certificate-public';
import Classroom from '../screens/classroom';
import Essay from '../screens/essay';
import AllEssay from '../screens/essay/all-essay';
import AllTopics from '../screens/essay/all-topics';
import Exam from '../screens/exercises/exam';
import StartExam from '../screens/exercises/start-exam';
import FeedbackEssay from '../screens/feedback-essay/FeedbackEssay';
import Library from '../screens/library';
import Paywall from '../screens/paywall/paywall';
import Quizzes from '../screens/quizzes';
import WriteEssay from '../screens/write-essay/WriteEssay';

export const Router: React.FC = () => {
  const basePath = microfrontendConfig.getBasePath();

  return (
    <BrowserRouter basename={basePath}>
      <Routes>
        <Route element={<ApplicationLayout />}>
          <Route path="/" element={<StudyPlan />} />
          <Route path="/library" element={<Library />} />
          <Route path="/practice" element={<Quizzes />} />
          <Route path="/essays" element={<Essay />} />
          <Route path="/essays/all" element={<AllEssay />} />
          <Route path="/essays/topics" element={<AllTopics />} />
          <Route path="/essays/feedback/:guid" element={<FeedbackEssay />} />
          <Route path="/essays/write" element={<WriteEssay />} />
          <Route path="/essays/write/:guid" element={<WriteEssay />} />
          <Route path="/exclusive-access" element={<Paywall />} />
        </Route>
        {/*classroom routes*/}
        <Route path="/classroom/course/:guid" element={<Classroom />} />
        <Route
          path="/classroom/study-plan/:weekOrder/course/:guid"
          element={<Classroom isStudyPlan={true} />}
        />
        <Route
          path="/classroom/live/course/:guid/:streamingGuid"
          element={<Classroom isLive={true} />}
        />

        <Route path="/certificate/public/:guid" element={<CertificatePublic />}></Route>

        <Route path="/exercises/confirmation/:guid" element={<StartExam />}></Route>
        <Route path="/exercises/exam/:guid" element={<Exam />}></Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
